module.exports = __webpack_public_path__ + "static/media/10-2.8b09defd.mp3";